import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'fluxible-router';
import { parse } from 'url';

const ArticleLink = ({
  children,
  external,
  forceFullReload,
  anchor,
  url
}) => {
  if (anchor) {
    return <a href={`#${anchor}`} data-anchor={anchor}>{children}</a>;
  }

  return (
    <NavLink
      className={external ? 'arrow-item' : ''}
      href={external ? url : parse(url).pathname}
      followLink={forceFullReload}
      activeClass="active"
    >
      {children}
      {external && <i className="icon-budicon-519" />}
    </NavLink>
  );
};

ArticleLink.propTypes = {
  children: PropTypes.node,
  external: PropTypes.bool,
  forceFullReload: PropTypes.bool,
  anchor: PropTypes.string,
  url: PropTypes.string
};

export default ArticleLink;
